import Box from "@material-ui/core/Box";
import {handleDirectLinkActivation} from "../../../utils/RouteUtils";
import LinearProgress from "@material-ui/core/LinearProgress";
import React from "react";


export default function QuickLink({fachobjektbezug, fachobjektId, history, hasFirstLevelEntlastungsanlagen, loading, setLoading, title}) {
    return (
        <Box
            component="span"
            color="#0288d1"
            onClick={() => {
                handleDirectLinkActivation(fachobjektbezug, fachobjektId, history, false, hasFirstLevelEntlastungsanlagen);
                setLoading(true);
            }}
        >
            {loading === false && <u>{title}</u>}
            {loading === true && (
                <LinearProgress style={{marginLeft: "var(--horizontal-spacing)", marginRight: "var(--horizontal-spacing)"}}/>
            )}
        </Box>
    );
}
